export const pluginId = 'content-type-builder';
